import { Alert } from "antd";
import Echeance from "../../Models/Echeance";
import formatNumber from "./FormatNumber"
import ReformatNumber from "./ReformatNumber";
import EcheanceFormat from "../../Models/EcheanceFormat";
import formatDate from "./fomatDate";

export default function ReFormatTabAmort(tab : EcheanceFormat[]) : Echeance[]{
    let t : Echeance[] = []
    for (let index = 0; index < tab.length; index++) {
        t.push(
            {
                numSeq : ReformatNumber(tab[index].numSeq),
                dateEcheacnce : tab[index].dateEcheacnce,
                capital : ReformatNumber(tab[index].capital),
                amortissement : ReformatNumber(tab[index].amortissement),
                interet : ReformatNumber(tab[index].interet),
                taxe : ReformatNumber(tab[index].taxe),
                epargne : ReformatNumber(tab[index].epargne),
                anHT : ReformatNumber(tab[index].anHT),
                anTTC : ReformatNumber(tab[index].anTTC)
            }
        )
        
    }
    return t;
}

